import Api from '@/services/Api'

export default {
    createParticipant (params, token) {
        return Api().post('/create-participant', params, {
            headers: { 'x-access-token': token }
        })
    },
    getParticipants (params, token) {
        return Api().post('/get-participants', params, {
            headers: { 'x-access-token': token }
        })
    },
    disableParticipant (params, token) {
        return Api().post('/disable-participant', params, {
            headers: { 'x-access-token': token }
        })
    },
    deleteParticipant (params, token) {
        return Api().post('/delete-participant', params, {
            headers: { 'x-access-token': token }
        })
    },
    deleteMultiParticipants (params, token) {
        return Api().post('/delete-participants', params, {
            headers: { 'x-access-token': token }
        })
    },
    changePass (params, token) {
        return Api().post('/changepw-participant', params, {
            headers: { 'x-access-token': token }
        })
    },

    createMultiParticipants (params, token) {
        return Api().post('/create-multi-participant', params, {
            headers: { 'x-access-token': token }
        })
    },
    getParticipantsByAdmin (params, token) {
        return Api().post('/get-participants-by-admin', params, {
            headers: { 'x-access-token': token }
        })
    },
    searchParticipants (params, token) {
        return Api().post('/search-participants', params, {
            headers: { 'x-access-token': token }
        })
    },
}